import React, { useEffect, useRef } from 'react';
import { StarIcon } from 'lucide-react';
export const TrustpilotReviews = () => {
  const trustboxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if ((window as any).Trustpilot && trustboxRef.current) {
      ;
      (window as any).Trustpilot.loadFromElement(trustboxRef.current, true);
    }
  }, []);
  return <section className="mb-12" data-id="element-381">
      <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-382">
        Wat cursisten over ons zeggen
      </h2>
      <div ref={trustboxRef} className="trustpilot-widget" data-locale="en-US" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-theme="light" data-token="23019ce4-308c-4f1c-8406-ce6ca64ac0c2" data-id="element-383">
        <a href="https://www.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-384">
          Trustpilot
        </a>
      </div>
    </section>;
};